import {
  RichTextHorizontalAlign,
  RichTextView,
  RichTextViewOpts,
} from '@play-co/timestep-core/ui';
import { Container } from './Container';
import { ITextStyle } from '../..';
import { FontName } from 'src/lib/ui/config';
import { bitmapFontFromFontID } from 'src/lib/bitmapFonts';

export class Text extends Container {
  protected _innerView!: RichTextView;

  constructor(text: string, style?: ITextStyle) {
    const font = (style?.font ?? 'Body') as FontName;
    super(
      new RichTextView({
        text,
        font: bitmapFontFromFontID(font)!,
        size: style?.fontSize ?? 24,
      }),
    );
    if (style) {
      this.style = style;
    }
  }

  public get text() {
    return this._innerView.text!;
  }

  public set text(text: string) {
    this._innerView.text = text;
  }

  public set style(style: ITextStyle) {
    if (style.fill != null) {
      this._innerView.color = style.fill;
    }
    if (style.fontSize != null) {
      this._innerView.size = style.fontSize;
    }
    if (style.align != null) {
      this._innerView.align = style?.align as RichTextHorizontalAlign;
    }
  }

  public setTextOpts(opts: RichTextViewOpts) {
    this._innerView.updateOpts(opts);
  }
}
